.skeleton {
  width: var(--haus-skeletonLoader__skeleton__width);
  height: var(--haus-skeletonLoader__skeleton__height);
  border-radius: var(--haus-skeletonLoader__skeleton__border-radius, 4px);
  border: var(--haus-skeletonLoader__skeleton__border, none);
  transition: var(--haus-skeletonLoader__skeleton__transition, none);
  margin: var(--haus-skeletonLoader__skeleton__margin, 0);
  padding: var(--haus-skeletonLoader__skeleton__padding, 0);
  background: var(--haus-skeletonLoader__skeleton__background, var(--skeleton-bg-shimmer));
  background-size: var(--haus-skeletonLoader__skeleton__background-size, 200% 100%);
  animation: shimmer var(--haus-skeletonLoader__skeleton__animation-duration, 1.5s) infinite
    ease-in-out;

  &.skeletonHidden {
    display: var(--haus-skeletonLoader__skeletonHidden__display, none);
  }
}

.container {
  width: var(--haus-skeletonLoader__container__width, 100%);
  height: var(--haus-skeletonLoader__container__height, 100%);
}

.containerLoading {
  visibility: var(--haus-skeletonLoader__containerLoading__visibility, hidden);
  position: var(--haus-skeletonLoader__containerLoading__position, absolute);
  z-index: var(--haus-skeletonLoader__containerLoading__z-index, -1);
}

@keyframes shimmer {
  0% {
    background-position: var(--haus-skeletonLoader__skeleton__background-position-0, -200% 0);
  }
  100% {
    background-position: var(--haus-skeletonLoader__skeleton__background-position-100, 200% 0);
  }
}
